<script>
export default {
  props: {
    src: { type: String, required: true, },
    isLoading: { type: String, required: true, },
    lightboxRef: { type: Object, default: null, },
  },

  computed: {
    itemStyle() {
      return {
        backgroundImage: `url(${this.src})`,
      };
    }
  }
}
</script>

<template>
  <div
    v-if="!isLoading"
    class="lightbox-preview-focus-image"
    :style="itemStyle"
    @click.prevent=""
  />
  <div
    v-else
    class="placeholder"
    style="height: 160px"
  />
</template>

<style scoped>
.lightbox-preview-focus-image {
  height: 220px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
</style>